// extracted by mini-css-extract-plugin
export var chevron = "_ax-2";
export var dropdownItems = "_ax-0";
export var item = "_ax-1";